import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  BankAccountApi,
  FilterBankAccountOptions,
  FindBankAccountQuery,
} from 'api';
import { bankAccountQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createBankAccount = createAsyncThunk(
  'bankAccount/createBankAccount',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await BankAccountApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterBankAccount = createAsyncThunk(
  'bankAccount/filterBankAccount',
  async (option: FilterBankAccountOptions, { rejectWithValue }) => {
    try {
      const response = await BankAccountApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeBankAccount = createAsyncThunk(
  'bankAccount/removeBankAccount',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BankAccountApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBankAccountByOwner = createAsyncThunk(
  'bankAccount/findBankAccountByOwner',
  async (option: FindBankAccountQuery, { rejectWithValue }) => {
    try {
      const response = await BankAccountApi.findBankAccountByOwner(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateBankAccount = createAsyncThunk(
  'bankAccount/updateBankAccount',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await BankAccountApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: bankAccountQuery,
};

const bankAccountSlice = createSlice({
  name: 'bankAccount',
  initialState,
  reducers: {
    reloadBankAccount(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findBankAccountByOwner.fulfilled, (state, action) => {
        const { data } = action.payload;

        state.tableList = data;
      })
      .addCase(filterBankAccount.fulfilled, (state, action) => {
        const { data } = action.payload;

        state.tableList = data;
      })
      .addCase(createBankAccount.fulfilled, (state, action) => {
        const data = action.payload;

        state.tableList = [...state.tableList, data];
      });
  },
});

const { actions, reducer: bankAccountReducer } = bankAccountSlice;

export const { reloadBankAccount } = actions;

export default bankAccountReducer;
